import React from 'react';
import {RevTextBanner, BlankRevContainer, RevExampleImg} from '../styles/load_cards_styles.js'

const BlankReviewPanel = (props) => {

  const review_img = require("../images/review_img.png")

  return(
    <BlankRevContainer>
      <RevTextBanner> Add a query to see query based reviews. </RevTextBanner>
      <RevExampleImg src={review_img} alt="no graph available"/>
    </BlankRevContainer>

  )
}

export default BlankReviewPanel;
